if (!customElements.get('facets-sidebar')) {
  class FacetsSidebar extends HTMLElement {
    mediaQuery = window.matchMedia('screen and (min-width: 990px)');
    selectors = {
      id: 'facets-sidebar',
      section: '.js-collection-inner',
      innerWrapper: '.js-sidebar-inner',
    };
    HEADER_HEIGHT = 145;
    CONTAINER_TOP_PADDING = 0;

    constructor() {
      super();
    }

    connectedCallback() {
      document.addEventListener('facets-trigger:click', this.toggle.bind(this));

      if (this.mediaQuery.matches) this.init();

      this.mediaQuery.addEventListener('change', this.handleResize.bind(this));
    }

    disconnectedCallback() {
      document.removeEventListener('facets-trigger:click', this.toggle);
    }

    toggle() {
      this.classList.toggle('open');
    }

    handleResize() {
      if (this.mediaQuery.matches) {
        this.init();
      } else {
        this.destroy();
      }
    }

    init() {
      this.sidebar = new StickySidebar(this.selectors.id, {
        containerSelector: this.selectors.section,
        innerWrapperSelector: this.selectors.innerWrapper,
        topSpacing: this.HEADER_HEIGHT + this.CONTAINER_TOP_PADDING,
        bottomSpacing: 0,
      });
      this.classList.remove('is-disabled');
    }

    destroy() {
      this.sidebar.destroy();
      this.classList.add('is-disabled');
    }
  }
  customElements.define('facets-sidebar', FacetsSidebar);
}
